import React, { useEffect, useState } from 'react';
import classes from "./MyMatches2.module.css";
import { useNavigate } from 'react-router-dom';
import { userMatchesApi } from '../../http/http';
import { useDispatch, useSelector } from 'react-redux';
import MatchLayoutNew2 from '../../component/NewComponents/MatchLayoutNew2';
import MatchLayoutForPrediction from '../../component/NewComponents/MatchLayoutForPrediction';
import SmallLoader from '../../component/SmallLoader';
import { removeUserDetails } from '../../store/slices/userSlice';
import { toast } from 'react-toastify';
import Header2 from '../../component/NewComponents/Header2';

const MyMatches2 = () => {
    const navigate = useNavigate();
    const [type, setType] = useState("fantasy");
    const [userMatches, setUserMatches] = useState(null);
    const { userDetails } = useSelector(state => state.persisted?.userSlice);

    const [loader, setLoader] = useState(true);
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();

    const fetchUserMatches = async (load) => {
        try {
            if (load) setLoading(true);
            setLoader(true);
            const response = await userMatchesApi(userDetails?.token);
            setUserMatches({
                fantasy: response?.data?.fantasy,
                prediction: response?.data?.prediction
            });
            setLoading(false);
            setLoader(false);
        } catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error("Login Again!");
                navigate('/');
            } else {
                setLoader(false);
                setLoading(false);
                toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || "Something Went Wrong!");
            }
        }
    };

    useEffect(() => { fetchUserMatches(true); }, []);

    useEffect(() => {
        if (!loader) {
            const intervalId = setInterval(() => {
                if (!document.hidden) fetchUserMatches(false);
            }, 10000);
            return () => clearInterval(intervalId);
        }
    }, [loader]);

    const fantasyList    = userMatches?.fantasy    ?? [];
    const predictionList = userMatches?.prediction ?? [];
    const activeList     = type === "fantasy" ? fantasyList : predictionList;

    return (
        <div className={classes.page}>
            <Header2 active={1} />

            <main className={classes.main}>

                {/* Hero bar */}
                <div className={classes.heroBar}>
                    <div className={classes.heroText}>
                        <span className={classes.heroEyebrow}>Your Activity</span>
                        <h1 className={classes.heroTitle}>My <em>Matches</em></h1>
                    </div>
                </div>

                {/* Type toggle */}
                <div className={classes.tabs_container}>
                    <button
                        type="button"
                        className={`${classes.tab_option} ${type === "fantasy" ? classes.active : ''}`}
                        onClick={() => setType("fantasy")}
                    >
                        ⚽ Fantasy Game
                        {fantasyList.length > 0 && type === "fantasy" && (
                            <span style={{ fontSize: 13, fontFamily: 'DM Sans, sans-serif', fontWeight: 600, opacity: 0.75 }}>
                                {fantasyList.length}
                            </span>
                        )}
                    </button>
                    <button
                        type="button"
                        className={`${classes.tab_option} ${type === "predict" ? classes.active : ''}`}
                        onClick={() => setType("predict")}
                    >
                        🎯 Predict &amp; Win
                        {predictionList.length > 0 && type === "predict" && (
                            <span style={{ fontSize: 13, fontFamily: 'DM Sans, sans-serif', fontWeight: 600, opacity: 0.75 }}>
                                {predictionList.length}
                            </span>
                        )}
                    </button>
                </div>

                {/* Content */}
                {loading ? (
                    <div className={classes.loaderWrap}>
                        <SmallLoader />
                        <p className={classes.loaderText}>Loading your matches…</p>
                    </div>
                ) : (
                    <div className={classes.matchGrid}>
                        {activeList.length > 0 ? (
                            activeList.map((match, index) => {
                                const match_details = match?.completed_match_details
                                    ? JSON.parse(match.completed_match_details)
                                    : match?.live_match_details
                                    ? JSON.parse(match.live_match_details)
                                    : null;

                                return type === "fantasy" ? (
                                    <MatchLayoutNew2
                                        match={match}
                                        match_details={match_details}
                                        key={index}
                                        index={index}
                                    />
                                ) : (
                                    <MatchLayoutForPrediction
                                        match={match}
                                        match_details={match_details}
                                        key={index}
                                        index={index}
                                    />
                                );
                            })
                        ) : (
                            <div className={classes.emptyState}>
                                <span className={classes.emptyEmoji}>
                                    {type === "fantasy" ? "⚽" : "🎯"}
                                </span>
                                <p className={classes.emptyTitle}>
                                    {type === "fantasy" ? "No Fantasy Teams Yet" : "No Predictions Yet"}
                                </p>
                                <p className={classes.emptySub}>
                                    {type === "fantasy"
                                        ? "Join an upcoming match to create your first fantasy team."
                                        : "Head to upcoming matches to make your first prediction."}
                                </p>
                            </div>
                        )}
                    </div>
                )}
            </main>
        </div>
    );
};

export default MyMatches2;